var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.14 269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.86,128.32c-6.43-.55-13.83-1.17-14.35-1.17a30.92,30.92,0,0,1-11.67-2.29,29.37,29.37,0,0,1-8.24-5.09,16.59,16.59,0,0,0-1.14,11c4.83,19.71,21,25.88,35.4,26.93Z",
    fill: "#546e7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.09,119.59c-15.4,24.64-42.69,47.83-71.75,47.83a52.62,52.62,0,0,1,0-105.24H98c4.39,0,9.57-4.78,9.57-9.57C177.76,51.43,160.22,86.11,141.09,119.59Z",
    fill: "#cfd8dc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122,33.48C95.53,20.27,47.08,23.9,46.62,23.85A12,12,0,1,1,49,.06c2,.2,50.28-1.86,80.69,20.33,11.4,8.32,8.31,10.14,5.35,16C132.94,40.63,123.67,34.35,122,33.48Z",
    fill: "#78909c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.14,67c0,15.85-32,14.35-47.83,14.35a28.7,28.7,0,0,1,0-57.4C152.15,23.92,184.14,38.27,184.14,67Z",
    fill: "#78909c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.82,29.15C86,13.13,40,18.9,38,18.94a12,12,0,0,0,.49,23.92c.43,0,43-8.4,71.19-.92A28.76,28.76,0,0,1,119.82,29.15Z",
    fill: "#b0bec5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.66,157.85v-56c-2.82,5.83-6.16,11.82-9.57,17.77A122.79,122.79,0,0,1,127,137.92l4.49,24.74s0,9.54,9.57,9.54h19.13v-4.78S160.22,157.85,150.66,157.85Z",
    fill: "#90a4ae"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.26,126.76c0,40.66-47.84,31.09-62.19,31.09V126.76a31.1,31.1,0,0,1,62.19,0Z",
    fill: "#90a4ae"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.82,157.85H31.07V172.2h81.32v-4.78A9.58,9.58,0,0,0,102.82,157.85Z",
    fill: "#90a4ae"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165,52.62H153.42c-9.56,0-12.33-14.35-12.33-14.35h11.73C162.39,38.27,165,52.62,165,52.62Z",
    fill: "#455a64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.05,
    cy: 45.44,
    r: 7.18
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.62,224.89v9.29H35.17V269H24.91V192.32H50.34v9.29H35.17v23.28Z",
    fill: "#37abc8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67,269H56.74V205.46q0-13.14,12.28-13.14h7.69Q89,192.32,89,205.46V269H78.74V240.91H67Zm11.75-37.38V206.1c0-3-1.49-4.49-4.49-4.49H71.48q-4.49,0-4.49,4.49v25.52Z",
    fill: "#37abc8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.72,212.93V206.2q0-4.59-4.49-4.59h-1.6c-2.92,0-4.37,1.53-4.37,4.59v12.71a3.75,3.75,0,0,0,.85,2.88,19.71,19.71,0,0,0,2.78,1.93l9.71,5.22a44.62,44.62,0,0,1,4.54,2.85,7,7,0,0,1,2.08,2.45q.75,1.44.75,5.5v16.34Q128,269,115.58,269h-6.3Q97,269,97,254.9v-3.85h10.26v4.17q0,4.48,4.58,4.48h1.82q4.07,0,4.06-4.48v-13a3.79,3.79,0,0,0-.85-2.88,22.16,22.16,0,0,0-2.78-1.92l-9.72-5.45a31.08,31.08,0,0,1-4.65-2.88A6.59,6.59,0,0,1,97.64,226a15.21,15.21,0,0,1-.64-4.86V205.46q0-13.14,12.28-13.14h6.41q12.27,0,12.28,13.14v7.47Z",
    fill: "#37abc8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.85,201.61V269H142.6V201.61h-9.82v-9.29h29.9v9.29Z",
    fill: "#37abc8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.b36b75b3cea2b109d834312e6dcd2f44.svg";
export { ForwardRef as ReactComponent };